import { Component, computed, input } from '@angular/core';
import { MmrService } from '../../../../services/mmr.service';
import { TelephoneLinkComponent } from '../../../../../../shared/components/telephone-link/telephone-link.component';
import { ClaimDetailsPanelInWarranty } from '../../../../types/mmr-claims.type';

@Component({
  selector: 'app-in-warranty',
  imports: [TelephoneLinkComponent],
  templateUrl: './in-warranty.component.html',
  styleUrl: './in-warranty.component.scss',
})
export class InWarrantyComponent {
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => {
    const { claims } = this.mmrService.planClaimsDetails;
    const claimValue = claims.value()?.[this.claimType()] as ClaimDetailsPanelInWarranty;

    return {
      claimType: this.claimType(),
      manufacturer: claims.value().itemDetails?.manufacturer,
      phoneNumber: claimValue?.planInWarrantyContactTel,
      postCode: claims.value()?.addressInformation?.postalCode,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}
}
